import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import SettingSurchargeCategoryService from "services/SettingSurchargeCategoryService";

export const getAllSettingSurchargeCategoryApi = createAsyncThunk(
  "settingSurchargeCategory/get-all",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SettingSurchargeCategoryService.getAll();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateSettingSurchargeCategoryApi = createAsyncThunk(
  "settingSurchargeCategory/update",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SettingSurchargeCategoryService.update(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  surchargeCategoryList: [],
};

export const settingSurchargeCategorySlice = createSlice({
  name: "settingSurchargeCategory",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSettingSurchargeCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllSettingSurchargeCategoryApi.fulfilled, (state, action) => {
        state.loading = false;
        state.surchargeCategoryList = action.payload;
      })
      .addCase(getAllSettingSurchargeCategoryApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateSettingSurchargeCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSettingSurchargeCategoryApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateSettingSurchargeCategoryApi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = settingSurchargeCategorySlice.actions;

export default settingSurchargeCategorySlice.reducer;